import API from '../api'
import {
  CART_ADD_ITEM,
  CART_REMOVE_ITEM, 
  CART_SAVE_SHIPPING_ADRESSE,
  CART_SAVE_PAYMENT,
  CART_MODAL_TOGGLE
} from '../constants/cartConstants'

export const addToCart = (id, qty) => async (dispatch, getState) => {
  const { data } = await API.get(`/products/${id}`)
  const product = data.product;

  if(!data.ok) throw new Error();

  dispatch({
    type: CART_ADD_ITEM,
    payload: {
      product: product._id,
      name: product.name,
      images: product.images,
      price: product.price,
      countInStock: product.countInStock,
      qty,
    },
  })

  localStorage.setItem('cartItems', JSON.stringify(getState().cart.cartItems))
}

export const clearCart = () => (dispatch, getState) => {
  dispatch({
    type: CART_REMOVE_ITEM,
    payload: null
  })
  localStorage.removeItem('cartItems')
}

export const removeFromCart= (id)=> (dispatch,getState)=>{
    dispatch({
      type: CART_REMOVE_ITEM,
      payload: id
    })
    localStorage.setItem('cartItems', JSON.stringify(getState().cart.cartItems))

}

export const saveAddressshipping = (data)=> (dispatch,getState)=>{
  dispatch({
    type: CART_SAVE_SHIPPING_ADRESSE,
    payload: data
  })
  localStorage.setItem('shippingAddress', JSON.stringify(data))

}
export const savepaymentmethod = (data)=> (dispatch,getState)=>{
  dispatch({
    type: CART_SAVE_PAYMENT,
    payload: data
  })
  localStorage.setItem('paymentMethod', JSON.stringify(data))

}

export const toggleCartModal = () => (dispatch, getState) => {
  dispatch({
    type: CART_MODAL_TOGGLE,
  })
}